module.exports = __webpack_public_path__ + "img/0x463E737D8F740395ABf44f7aac2D9531D8D539E9.f67776a2.png";